<template>
  <div>
    <b-card>
      <b-row>
        <div class="col-lg-5">
          <label class="w-100 border-bottom pb-2 label-header mb-3">Wallet Information</label>
          <div class="d-flex flex-wrap">
            <div class="d-flex mb-3 col-lg-6">
              <i class="mdi mdi-wallet me-2" style="margin-top: 6px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">E-Renta Wallet</p>
                <label class="mb-1">₱{{ eRentaFunds == 0 ? '0.00' : eRentaFunds.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-globe me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Account Number</p>
                <label class="mb-1">--</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-user-circle me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Store Owner</p>
                <label class="mb-1">{{ businessDetails.subscriberName }}</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-store-alt me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Business Name</p>
                <label class="mb-1">{{ businessDetails.businessName }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <label class="w-100 border-bottom pb-2 label-header mb-3">Financial Overview</label>
          <div class="d-flex flex-wrap">
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Monthly Incoming</p>
                <label class="mb-1">₱{{ eRentaMonthlyIncoming == null ? '0.00' : eRentaMonthlyIncoming.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Monthly Outgoing</p>
                <label class="mb-1">₱{{ eRentaMonthlyOutgoing == null ? '0.00' : eRentaMonthlyOutgoing.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Daily Incoming</p>
                <label class="mb-1">₱{{ eRentaDailyIncoming == null ? '0.00' : eRentaDailyIncoming.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
                <p class="mb-1 fs-13px">as of {{ new Date() | formatDate }}</p>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Daily Outgoing</p>
                <label class="mb-1">₱{{ eRentaDailyOutgoing == null ? '0.00' : eRentaDailyOutgoing.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</label>
                <p class="mb-1 fs-13px">as of {{ new Date() | formatDate }}</p>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </b-card>

    <!-- Table Card-->
    <b-card>
      <div class="d-flex align-items-center mb-4">
        <h5 class="mb-0">{{ eRentaTxnTotal }} Record(s)</h5>
        <button class="btn btn-secondary ms-auto" @click="getErentaTransactions()">
          <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp; Refresh
        </button>
      </div>

      <div class="d-flex flex-wrap mb-4">
        <div class="ta-right me-3">
          <b-form-group description="Search Keyword">
            <div class="d-flex">
              <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width: fit-content"
                    id="input-3" v-model="search.field" :options="searchFields"></b-form-select>
              <b-form-input class="rounded-0 rounded-end" v-model="search.keyword"></b-form-input>
            </div>
          </b-form-group>
        </div>
        <div class="ta-right me-3">
          <b-form-group description="Filter by Status">
            <b-form-select class="form-select rounded shadow-none status-form-select"
              v-model="search.status"
              :options="statusOptions"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="ta-right me-3">
          <b-form-group description="Filter by Transaction Date">
            <flat-pickr
              v-model="search.dateRange"
              :config="rangeOptions"
              placeholder="Select a date range"
              class="form-control"
              style="width: fit-content"
            ></flat-pickr>
          </b-form-group>
        </div>
        <button type="button" class="btn btn-primary h-fit me-3" @click="isSearching=true; getErentaTransactions()">
          <i class='bx bx-search bx-fw'></i>Search
        </button>
        <button class="btn btn-primary h-fit" @click="onExport()">
          <i class="uil uil-export me-1"></i>Export
        </button>
      </div>

      <!-- Table -->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :fields="tableFields"
            :items="eRentaTxn"
            responsive="sm"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="table-check"
            @sort-changed="tableSorting()">

            <template #cell(status)="data">
              <div :class="{
                'success': data.item.status == 'success' || data.item.status == 'confirmed',
                'failed': data.item.status == 'failed' || data.item.status == 'rejected',
                'processing': data.item.status == 'processing'
              }">
                {{ setStatus(data.item.status) }}</div>
            </template>

            <template #cell(cashout_type)="data">
              <div>{{ data.item.cashout_type == 'eload' ? 'E-Load' : data.item.cashout_type == 'bills' ? 'Bills Payment' : 'Other Bank' }}</div>
            </template>

            <template #cell(amount)="data">
              <div>₱{{ data.item.amount.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</div>
            </template>

            <template #cell(transaction_fee)="data">
              <div>₱{{ data.item.transaction_fee.toLocaleString(undefined, {minimumFractionDigits: 2}) }}</div>
            </template>

            <template #cell(created_at)="data">
              {{ data.item.created_at | formatDate }}
            </template>
          </b-table>
        </div>
      </div>
      
      <div class="row g-0 text-center" v-if="eRentaTxnTotal == 0">
        <span>No data to display.</span>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group d-flex align-items-center">
            <label class="me-4 mb-0">Display:</label>
            <b-form-group label-for="display-record">
              <b-form-select class="form-select shadow-none w-fit"
                id="display-record"
                v-model="perPage"
                :options="pageOptions"
                @change="getErentaTransactions()"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>

        <!-- pagination -->
        <div class="col-lg-6">
          <div class="dataTables_paginate paging_simple_numbers float-end" v-if="eRentaTxnTotal > perPage">
            <b-pagination
              class="pagination-rounded"
              v-model="currentPage"
              :total-rows="eRentaTxnTotal"
              @input="getErentaTransactions()"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import appConfig from "@/app.config";
// import { required } from "vuelidate/lib/validators";
import { customerMethods, customerListComputed, eRentaMethods, eRentaComputed, exportMethods, layoutMethods } from "@/state/helpers";
import Swal from 'sweetalert2';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  page: {
    title: "E-Renta Transaction",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      transactions: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "",
      sortDesc: true,
      businessId: 0,
      search: {
        field: null,
        keyword: null,
        status: null,
        dateRange: null,
      },
      searchFields: [
        { text: "Search All", value: null },
        { text: "Transaction ID", value: "w.txn_ref_id" },
        { text: "Account Number", value: "w.account_no" },
        { text: "Account Name", value: "w.account_name" },
      ],
      statusOptions: [
        { text: "All", value: null },
        { text: "Success/Confirmed", value: "confirmed" },
        { text: "Failed/Rejected", value: "rejected" },
        { text: "Processing", value: "pending" },
      ],
      rangeOptions: {
        mode: "range",
      },
      tableFields: [
        { key: "txn_ref_id", label: "Transaction ID", sortable: true, },
        { key: "account_no", label: "Account Number", sortable: true, },
        { key: "account_name", label: "Account Name", sortable: true, },
        { key: "cashout_type", label: "Action Transfer", sortable: true, },
        { key: "status", label: "Payment Status", sortable: true, },
        { key: "amount", label: "Amount", sortable: true, },
        { key: "transaction_fee", label: "Service Fee", sortable: true, },
        { key: "created_at", label: "Date", sortable: true, },
      ],
      isSearching: false,
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...customerListComputed,
    ...eRentaComputed,
  },
  async mounted() {
    this.businessId = this.$route.params.bid;
    this.changeTitle({ title: "E-Renta Transaction" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Merchant List", to: { name: "Subscriber" } },
        { text: "Merchant Details", to: { name: "Profile Information", params: { tab: 'Profile', bid: this.businessId} } },
        { text: "E-Renta Transaction", to: { name: "" } },
      ],
    });
    this.getBusinessDetails({ id: this.businessId });
    this.getErentaFunds({ businessId: this.businessId });
    this.getErentaIncome({ businessId: this.businessId });
    this.getErentaTransactions();
  },
  methods: {
    ...layoutMethods,
    ...customerMethods,
    ...eRentaMethods,
    ...exportMethods,
    async getErentaTransactions() {
      this.currentPage = this.isSearching ? 1 : this.currentPage;
      this.perPage = this.isSearching ? 10 : this.perPage;
      let params = {
        businessId: this.businessId,
        page: this.currentPage,
        limit: this.perPage,
        search: {
          searchField: this.search.field,
          keyword: this.search.keyword,
          status: this.search.status,
          dateRange: this.search.dateRange,
        },
        sortBy: this.isSearching ? "" : this.sortBy,
        sortOrder: this.isSearching ? "DESC" : this.sortDesc ? "DESC" : "ASC" ,
      }

      await this.getErentaTxn(params)
        .then(() => {
          this.transactions = this.eRentaTxn;
          this.isSearching = false;
        })
    },
    async onExport(){
      if(this.eRentaTxnTotal == 0){
        Swal.fire("Export Cannot Proceed!", "No record(s) to export.", "info");
        return;
      }

      let params = {
        module: "kantoads_erenta_txn",
        businessId: this.businessId,
        email: JSON.parse(localStorage.getItem("userData")).email,
        search: {
          searchField: this.search.field,
          keyword: this.search.keyword,
          status: this.search.status,
          dateRange: this.search.dateRange,
        },
        sortBy: this.isSearching ? "" : this.sortBy,
        sortOrder: this.isSearching ? "DESC" : this.sortDesc ? "DESC" : "ASC" ,
      };
      
      this.exportReport(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
    setStatus(status) {
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
    async tableSorting(action) {
      this.isSearching = true;
      this.sortBy = action.sortBy;
      this.sortDesc = action.sortDesc;
      await this.getErentaTransactions();
    }
  },
};
</script>

<style>
.mdi-wallet,
.bx-globe,
.bx-user-circle,
.bx-store-alt {
  font-size: 25px;
  color: #7f4697;
}

.label-header {
  font-size: 16px;
}

.fs-13px {
  font-size: 13px;
}

.status-form-select {
  width: 170px;
}

.success {
  color: #508F30;
}

.failed {
  color: #C12928;
}

.processing {
  color: #F7CC53;
}
</style>
